<template>
    <div class="ui-page">
        <ui-page-header :title="page.title" back="/blog/posts" back-text="Postagens">
            <v-btn v-if="(page.isNew) && $allowed('save')" id="btnSave" color="primary" depressed :loading="dataForm.addLoading" @click="add">Salvar</v-btn>
            <v-btn v-else-if="$allowed('save')" id="btnSave" color="primary" depressed :loading="dataForm.updateLoading" @click="update">Salvar</v-btn>
        </ui-page-header>

        <v-form :readonly="!$allowed('save')" ref="form" v-model="dataForm.validForm">
            <ui-section title="Detalhes">
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field dense label="Título" v-model="dataset.data.title" outlined
                            hide-details="auto">
                        </v-text-field>
                        <!-- <v-text-field label="Título" v-model="dataset.data.title" required
                            :rules="[$rules.required]" outlined hide-details="auto">
                        </v-text-field> -->
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-select id="type" dense :items="dataset.categories" label="Categoria"
                            v-model="dataset.data.category_id" item-value="id" item-text="name" outlined
                            hide-details="auto">
                        </v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-file-input dense accept="image/png, image/jpeg, application/pdf"
                            prepend-icon="" outlined counter :required="!dataset.data.cover_file"
                            :rules="[!dataset.data.cover_file ? $rules.required : null, $rules.fileSize(15)]"
                            hint="O arquivo não pode ser superior a 15MB" hide-details="auto"
                            label="Imagem" :clearable="true" @change="onFileSelected($event)"
                            ref="logoFile">
                        </v-file-input>

                        <v-img v-if="dataset.data.cover_image_url"
                            @click="openDoc(dataset.data.cover_image_url)" class="rounded-xl"
                            :height="100" :width="100" :src="dataset.data.cover_image_url">
                        </v-img>

                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <p class="font-weight-bold">Conteúdo</p>
                        <tiptap-vuetify v-model="dataset.data.content" :rules="[$rules.required]"
                            :extensions="extensions" hide-details="auto" />
                    </v-col>
                </v-row>
            </ui-section>
        </v-form>

        <v-dialog v-model="dialogViewDoc" max-width="60%">
            <v-card>
                <v-img :src="selectedDoc" alt="" contain />
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import states from "@/common/data/states.data"
import string from "@/common/util/string"

import axios from "axios"

import {
    TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Paragraph
} from 'tiptap-vuetify'


export default {
    name: "PostDetails",

    components: { 'tiptap-vuetify': TiptapVuetify },

    data: () => ({
        page: {
            isNew: false,
            title: "",
        },
        dataset: {
            breadcrumbItems: [],
            data: {
                category_id: null
            },
            categories: [],
        },
        dialogDynamicText: false,
        dynamicTextSmallType: false,
        selectedDoc: null,
        dialogViewDoc: false,
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            showPassword: false,
            showPasswordConfirmation: false,
        },
        extensions: [
            Underline,
            Strike,
            Italic,
            Bold,
            Paragraph,
        ],
    }),

    created() {
        this.loadData()
    },

    methods: {
        goBack() {
            this.$router.replace("/blog/posts");
        },

        openDoc(cover) {
            this.selectedDoc = cover;
            this.dialogViewDoc = true;
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();

            await this.loadCategories()
            await this.load();

        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = `${this.page.isNew ? 'Nova postagem' : 'Detalhes da postagem'}`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Postagens",
                disabled: false,
                to: "/blog/posts",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.title,
                disabled: true,
                exact: true,
            });
        },

        async load() {

            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/posts/${this.$route.params.id}`);
                console.log('result ', result)

                const data = result.data.content;

                this.dataset.data = data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadCategories() {

            try {
                const result = await axios.get(`/api/categories`, { params: { start: 1, limit: 100000, search: {} } });

                this.dataset.categories = [{ id: null, name: "Sem categoria" }, ...result.data.content];


            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir a postagem?',
                title: 'Incluir postagem',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post('/api/admin/posts', payload);

                this.$dialog.notify.info("Postagem salva com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }

        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar a postagem?',
                title: 'Atualizar postagem',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/api/admin/posts/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Postagem salva com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        onFileSelected(file) {
            this.dataset.data.file = file;
        },

        buildPayload() {
            const formData = new FormData()

            if (this.dataset.data.title)
                formData.append('title', this.dataset.data.title);

            if (this.dataset.data.content)
                formData.append('content', this.dataset.data.content);

            if (this.dataset.data.category_id)
                formData.append('category_id', this.dataset.data.category_id);

            if (this.dataset.data.file)
                formData.append('cover_image', this.dataset.data.file)

            return formData;
        },

    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
</style>